import { FilterSourceModel, FilterSourcesModel } from '@leverege/molten/filters';
import RsrcFilterModel from "../../filter/RsrcFilterModel.js";
import RsrcSortModel from "../../filter/RsrcSortModel.js";
const isEmptyFilter = value => {
  if (value == null) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  return Object.keys(value).length === 0;
};
const isEmptySort = value => {
  if (value == null) {
    return true;
  }
  return value.length === 0;
};
export default {
  id: 'rsrc.DefaultFiltersBlocker',
  sort: -999,
  matches: {
    client: ['GroupScreen'],
    objectType: 'rsrc'
  },
  execute: ({
    onFilterChange,
    filters
  }) => {
    let nSource = FilterSourcesModel.getSource(filters, 'filterBar');
    const oldFilter = FilterSourceModel.getFilter(nSource);
    const oldSort = FilterSourceModel.getSort(nSource);
    let hasEmpty = false;
    if (isEmptyFilter(oldFilter)) {
      hasEmpty = true;
      const rsrcFilterModel = RsrcFilterModel.create();
      nSource = FilterSourceModel.setMetadata(nSource || FilterSourceModel.create(), {
        ...FilterSourceModel.getMetadata(nSource),
        filter: rsrcFilterModel
      });
      nSource = FilterSourceModel.setFilter(nSource, RsrcFilterModel.toRsrcFilter(rsrcFilterModel));
    }
    if (isEmptySort(oldSort)) {
      hasEmpty = true;
      const rsrcSortModel = RsrcSortModel.create();
      nSource = FilterSourceModel.setMetadata(nSource || FilterSourceModel.create(), {
        ...FilterSourceModel.getMetadata(nSource),
        sort: rsrcSortModel
      });
      nSource = FilterSourceModel.setSort(nSource, RsrcSortModel.toRsrcOrder(rsrcSortModel));
    }
    if (hasEmpty) {
      onFilterChange({
        data: 'filterBar',
        value: nSource,
        isOnMount: true
      });
    }
  }
};